import ApiClient from './ApiClient';

class CampaignsReportsAPI extends ApiClient {
  constructor() {
    super('campaign_reports', { accountScoped: true });
  }
}

export default new CampaignsReportsAPI();
